<template>
  <v-container>
    <v-row>
      <v-col>
        <v-btn
          to="/biz-customers/create"
          small
        >
          <v-icon small>mdi-plus</v-icon>
          New biz customer
        </v-btn>
      </v-col>
    </v-row>

    <app-search
      :attribute_list="search_attribute"
      @setSearchParam="setSearchParam"
    />

    <app-data-table
      :list_name="'biz-customer'"
      :header_list="headers"
      :attribute_list="attribute_list"
      :search_param="search_param"
      :url="`/biz-customers`"
    />
  </v-container>
</template>

<script>
export default {
  name: "BizCustomerList",
  components: {
    AppDataTable: () => import('../../../components/AppDataTable'),
    AppSearch: () => import('../../../components/AppSearch'),
  },
  data: () => ({
    headers: [
      { text: 'Id', value: 'id' },
      { text: 'Company Name', value: 'company_name' },
      { text: '', value: 'actions', sortable: false }
    ],
    search_attribute: ['company_name'],
    search_param: '',
    attribute_list: ['id', 'company_name'],
  }),
  methods: {
    setSearchParam (val) {
      this.search_param = val
    }
  },
};
</script>
